
export const ACCESS_TYPE = 'sse'; // ws or sse 标志链接方式
export const PROCESS_ENV = {
    SERVER_ENV: 'prod',
    WS_BASE_URL: 'wss://wss.lke.cloud.tencent.com',
    SSE_BASE_URL: 'https://wss.lke.cloud.tencent.com',
    API_BASE_URL: 'https://lke.cloud.tencent.com/cgi/capi',
}
export const TOKENS_STATUS = {
    success: 'success',
    error: 'failed',
    pending: 'processing'
};
export const THOUGHT_STATUS = {
    success: 'success',
    failed: 'failed',
    processing: 'processing',
    stop: 'stop'
};

// type: Q-问题，A-答案，H-历史消息，S-停止生成，C-结束会话，T-转接会话，R-参考来源，F-点赞/点踩回执,RC-推荐问题
export const MESSAGE_TYPE = {
    QUESTION: 'Q',
    ANSWER: 'A',
    HISTORY: 'H',
    STOP: 'S',
    CLOSE: 'C',
    TRANSFER: 'T',
    REFERENCE: 'R',
    FEEDBACK: 'F',
    WORKBENCH_HISTORY: 'WH',
    RECOMMENDED: 'RC'
};

